var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.checkboxClasses }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.checkboxValue,
          expression: "checkboxValue"
        }
      ],
      attrs: { name: _vm.name, type: "checkbox", disabled: this.disabled },
      domProps: {
        checked: Array.isArray(_vm.checkboxValue)
          ? _vm._i(_vm.checkboxValue, null) > -1
          : _vm.checkboxValue
      },
      on: {
        change: [
          function($event) {
            var $$a = _vm.checkboxValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.checkboxValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.checkboxValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checkboxValue = $$c
            }
          },
          _vm.notify
        ]
      }
    }),
    _vm._v(" "),
    _c("label", { on: { click: _vm.toggle } }, [
      _vm._v(
        _vm._s(_vm.model && _vm.labelChecked ? _vm.labelChecked : _vm.label)
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eead2e8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eead2e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Checkbox.vue
// module id = 39fv
// module chunks = 1